/*
 * Swal delete confirmations
 * Requires data-delete-confirmation="true" and data-delete-text="" attributes
 */

import Swal from 'sweetalert2';

/*
* Confirmation for delete
*/
$('[data-delete-confirmation="true"]').on('click', function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  const $this = $(this);
  let text = $this.data('delete-text');
  const url = $this.attr('href');


  if (typeof text === 'undefined') {
    text = 'Er du sikker på at du vil slette?';
  }

  Swal.fire({
    title: 'Bekreft sletting',
    text,
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Ja, Slett!',
    cancelButtonText: 'Avbryt',
  }).then((result) => {
    if (result.value) {
      if ($this.attr('type') === 'submit') {
        $this.closest('form').submit();
      } else {
        window.location = url;
      }
    }
  });
});

/*
* Confirmation for duplicate
*/
$('[data-duplicate-confirmation="true"]').on('click', function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  const $this = $(this);
  let text = $this.data('duplicate-text');
  const url = $this.attr('href');

  if (typeof text === 'undefined') {
    text = 'Er du sikker på at du vil duplisere?';
  }

  Swal.fire({
    title: 'Bekreft duplisering',
    text,
    type: 'info',
    showCancelButton: true,
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Ja, Dupliser!',
    cancelButtonText: 'Avbryt',
  }).then((result) => {
    if (result.value) {
      if ($this.attr('type') === 'submit') {
        $this.closest('form').submit();
      } else {
        window.location = url;
      }
    }
  });
});
